import { useState } from "react";
import { Flex } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { creditCardImage } from "../../../utils/utils";
import CustomImage from "../../../components/image";
import CustomModal from "../../../components/modal";
import ModalFooter from "../../../components/modal/ModalFooter";
import ModalContent from "../../../components/modal/ModalContent";

const PaymentItem = ({
  data = {},
  onAddClick,
  onCardDelete,
  selected,
  disabled,
  handleSelectedItemChange,
}) => {
  const { last4, cardType, provider } = data;
  const isCard = !!data.id;
  const isLegacyCard = isCard && provider !== "nmi";
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = (id) => {
    setLoading(true);
    onCardDelete(id)
      .then(() => setDeleteModalOpen(false))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Flex
        className={`payment-item ${selected ? "payment-item-selected" : ""} ${
          disabled ? "payment-item-disabled" : ""
        }`}
        justify="space-between"
        align="center"
        onClick={disabled ? undefined : handleSelectedItemChange}
      >
        <Flex gap={14} align="center" flex={1} onClick={onAddClick}>
          <div className="image-wrapper">
            {isCard ? (
              <CustomImage
                src={
                  creditCardImage[cardType] ||
                  require("../../../components/images/default.png")
                }
              />
            ) : (
              <div className="add-new-card-image flex-container-center cursor-pointer">
                <PlusOutlined className="text-primary text-xl" />
              </div>
            )}
          </div>
          {isCard ? (
            <div>
              <p>{cardType}</p>
              <p className="text-gray">Last digits.... {last4}</p>
            </div>
          ) : (
            <p className="is-link text-semibold">Add a credit card</p>
          )}
        </Flex>
        {isCard && (
          <div
            className="text-error cursor-pointer"
            onClick={(event) => {
              event.stopPropagation();
              setDeleteModalOpen(true);
            }}
          >
            <DeleteOutlined className="text-xl" />
          </div>
        )}
      </Flex>
      {isLegacyCard && (
        <div className="legacy-card-warning">
          <p className="legacy-card-warning-title">
            ⚠️ Action Required: Re-attach Your Card
          </p>
          <p>
            The payment system is undergoing updates. To keep your payments
            running smoothly, please remove your current card and attach it
            again.
          </p>
          <p>Thanks for your patience!</p>
        </div>
      )}
      <CustomModal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        footer={null}
        content={
          <>
            <ModalContent text={"Are you sure you want to delete your card?"} />
            <ModalFooter
              submitTitle={"Delete"}
              onSubmit={() => handleDelete(data.id)}
              onCancel={() => setDeleteModalOpen(false)}
              loading={loading}
              disabled={loading}
              type="default"
              danger
            />
          </>
        }
      />
    </>
  );
};

export default PaymentItem;
